import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import HappinessEMAuthentication from '@ui/components/HappinessEMAuthentication';
import './App.css';
import './font.css';
function App() {
    useEffect(() => {
        // Disable browser back/forward cache for the application
        // This prevents cached application state from being restored
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (let registration of registrations) {
                    registration.unregister();
                }
            });
        }
    }, []);
    return (_jsx("div", { children: _jsx(HappinessEMAuthentication, {}) }));
}
export default App;
